import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl } from '../../util/reactIntl';
import { LayoutSingleColumn, Page } from '../../components';
import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import DefaultPage from './sections/DefaultPage';
import AustraliaPage from './sections/AustraliaPage';
import CanadaPage from './sections/CanadaPage';
import EuropePage from './sections/EuropePage';
import USAPage from './sections/USAPage';

import css from './HouseSittingAbroadPage.module.css';

const locationComponents = {
    default: DefaultPage,
    australia: AustraliaPage,
    canada: CanadaPage,
    europe: EuropePage,
    usa: USAPage,
};

const getTitle = (intl) => ({
    default: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaTitle.default' }),
    australia: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaTitle.australia' }),
    canada: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaTitle.canada' }),
    europe: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaTitle.europe' }),
    usa: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaTitle.usa' }),
});

const getDescription = (intl) => ({
    default: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaDescription.default' }),
    australia: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaDescription.australia' }),
    canada: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaDescription.canada' }),
    europe: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaDescription.europe' }),
    usa: intl.formatMessage({ id: 'HouseSittingAbroadPage.schemaDescription.usa' }),
});

const HouseSittingAbroadPageComponent = ({ params, scrollingDisabled }) => {
    // console.log({ params })
    const { location } = params;
    // console.log({ location })
    const intl = useIntl();

    const SelectedLocation = location ? locationComponents[location] : locationComponents['default'];

    const title = getTitle(intl);
    const description = getDescription(intl);

    const schemaTitle = location ? title[location] : title['default'];
    const schemaDescription = location ? description[location] : description['default'];

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            title={schemaTitle}
            description={schemaDescription}
        >
            <LayoutSingleColumn
                topbar={<TopbarContainer />}
                footer={<SectionFooter />}
                mainColumnClassName={css.mainColumnClassName}
            >
                <SelectedLocation />
            </LayoutSingleColumn>
        </Page >
    );
};


const mapStateToProps = state => {
    return {
        scrollingDisabled: isScrollingDisabled(state),
    };
}

const HouseSittingAbroadPage = compose(connect(mapStateToProps))(HouseSittingAbroadPageComponent);


export default HouseSittingAbroadPage;
